<script module lang="ts">
    export type TimeVal = { hour: number; min: number; sec: number };
    export type Props = {
        label?: string;
        description?: string;
        error?: null | string;
        value?: TimeVal;
        class?: string;
        args?: HTMLInputAttributes;
    };
    const withZeros = (num: number) => String(num).padStart(2, '0');
    export const strToTime: (str?: string) => TimeVal | undefined = (str) => {
        if (str == null) return undefined;
        const parts = str.split(':');
        return { hour: Number(parts[0]), min: Number(parts[1]), sec: Number(parts[2]) };
    };
    export const timeToStr: (time?: TimeVal) => string | undefined = (time) =>
        time ? `${withZeros(time.hour)}:${withZeros(time.min)}:${withZeros(time.sec)}` : undefined;
</script>

<script lang="ts">
    import type { HTMLInputAttributes } from 'svelte/elements';
    import { Input } from '@/components/ui/input/index.js';
    import InputError from '@/components/InputError.svelte';
    import { Label } from '@/components/ui/label/index.js';
    import FieldDescription from './FieldDescription.svelte';

    let { label, description, error, value = $bindable(), ...args }: Props = $props();
</script>

<div class="my-1 flex flex-col gap-2">
    {#if label}
        <Label for={label}>{label}</Label>
    {/if}
    {#if description}
        <FieldDescription>{description}</FieldDescription>
    {/if}
    <Input
        id={label}
        class="block w-full"
        bind:value={() => timeToStr(value), (val) => (value = strToTime(val))}
        {...args}
        type="time"
        step="2"
    />
    {#if error}
        <InputError message={error} />
    {/if}
</div>
